<template>
<v-container id="bulletin" pt-0 pb-3 px-3>
  <v-container id="bulletin-container" pa-0>
    <v-flex fill-height align-center d-flex>
      <v-img :src="step.url.url" contain max-height="100%" max-width="100%"></v-img>
    </v-flex>
  </v-container>
</v-container>
</template>

<script>

export default {
  name: 'bulletin',
  props: {
    step: {
      type: Object,
      default: () => {}
    },
  }
}
</script>

<style scoped>
#bulletin {
  position: absolute;
  top: 110px;
  bottom: 0px;
}

#bulletin-container {
  height: 90%;
}
</style>
